import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Video } from '../models/video';
import { HttpClient, HttpResponse } from '@angular/common/http';

const dataservice = 'assets/data/mock-video-data.json';

@Injectable({
  providedIn: 'root'
})
export class VideoService {

  video: Video = new Video();

  constructor(private http: HttpClient) { }

  getVid(): Observable<HttpResponse<Video[]>> {
    return this.http.get<Video[]>(
      dataservice, {observe: 'response'}
    );
}}
